import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from 'react';
import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom';
import { cn } from '@/utils/cn';

interface InternalLinkProps extends RouterLinkProps {
  external?: false;
  className?: string;
  children?: ReactNode;
}

interface ExternalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  external: true;
  href: string;
  className?: string;
  children?: ReactNode;
}

export type LinkProps = InternalLinkProps | ExternalLinkProps;

const baseClasses =
  'text-brand-700 underline-offset-4 hover:underline focus-visible:underline rounded-sm transition-colors';

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  if (props.external) {
    const { external: _external, className, children, ...rest } = props;
    return (
      <a
        ref={ref}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(baseClasses, className)}
        {...rest}
      >
        {children}
      </a>
    );
  }
  const { className, children, ...rest } = props;
  return (
    <RouterLink ref={ref} className={cn(baseClasses, className)} {...rest}>
      {children}
    </RouterLink>
  );
});

Link.displayName = 'Link';
